import React, { ComponentProps } from "react";

import { endOfDay, isValid as isValidDate } from "date-fns";
import { Controller } from "react-hook-form";

import FormDateField from "@src/sharedComponents/Forms/FormDateField";
import FormDropdownField from "@src/sharedComponents/Forms/FormDropdownField";
import FormTextField from "@src/sharedComponents/Forms/FormTextField";

const formFieldRules = {
  householdName: {
    required: "Household name is required",
    minLength: {
      value: 1,
      message: "Household name must not be empty",
    },
  },
  establishedAt: {
    validate: {
      isDateValid: (value: Date | null) =>
        !value || isValidDate(value) || "Please enter a valid date",
      isNotFuture: (value: Date | null) =>
        !value ||
        value <= endOfDay(new Date()) ||
        "Date cannot be in the future",
    },
  },
};

export function HouseholdNameFormField({
  label = "Household Name",
}: {
  label?: string;
}) {
  return (
    <FormTextField
      name="householdName"
      label={label}
      rules={formFieldRules.householdName}
    />
  );
}
export function HouseholdEstablishedAtFormField({
  label = "Date Established (Optional)",
}: {
  label?: string;
}) {
  return (
    <FormDateField
      name="establishedAt"
      label={label}
      maxDate={endOfDay(new Date())}
      rules={formFieldRules.establishedAt}
    />
  );
}

export function HouseholdMemberFormField({
  name,
  label,
  rules,
  clientsOptions,
  isLoading = false,
}: {
  name: string;
  label: string;
  rules?: ComponentProps<typeof Controller>["rules"];
  clientsOptions: Array<{ label: string; value: string }>;
  isLoading: boolean;
}) {
  return (
    <FormDropdownField
      name={name}
      label={label}
      values={clientsOptions}
      isLoading={isLoading}
      getOptionKey={(option) => option.value}
      rules={rules}
      disablePortal={false}
    />
  );
}

export function HouseholdAdvisorFormField({
  name,
  label,
  rules,
  advisorOptions,
  isLoading = false,
}: {
  name: string;
  label: string;
  rules?: ComponentProps<typeof Controller>["rules"];
  advisorOptions: Array<{ label: string; value: string }>;
  isLoading: boolean;
}) {
  return (
    <FormDropdownField
      name={name}
      label={label}
      values={advisorOptions}
      isLoading={isLoading}
      getOptionKey={(option) => option.value}
      rules={rules}
      disablePortal={false}
    />
  );
}
